import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActionItem, AppClientConfigurationService, AppServerAPI } from '@sdbn/common';
import { AsyncSubject, interval, Subscription } from 'rxjs';
import { Transport } from '../../../../common/model/transport.model';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { TransportDetailsLayoutConverter } from './../../../../common/components/tmp/transport-details-layout-converter.service';
import { TransportDetailLayout, TransportDetailMode } from './../../../../common/configuration/transport.configuration';
import { TransportDetailsLayoutService } from './../../../transport-details/transport-details-layout.service';
import { RegisterLeaveCombinedComponent, RegisterLeaveCombinedDialogData } from './../../../visit-overview/component/register-leave-combined/register-leave-combined.component';
import { RegisterLeaveComponent, RegisterLeaveDialogData } from './../../../visit-overview/dialog/register-leave/component/register-leave.component';
import { VisitService } from './../../../visit-overview/service/visit.service';

@Component({
  selector: 'app-action-tablet-transport-item',
  templateUrl: './action-tablet-transport-item.component.html',
  styleUrls: ['./action-tablet-transport-item.component.scss']
})
export class ActionTabletTransportItemComponent implements OnInit, OnDestroy {

  TransportDetailMode = TransportDetailMode;

  @Input() actionItem: ActionItem;

  transports = new Array<Transport>();

  clientParameters = TMCClientParameters;

  layoutDefinition: TransportDetailLayout;

  timerSubscription: Subscription;

  constructor(
    public cps: AppClientConfigurationService,
    private appServerApi: AppServerAPI,
    private dialog: MatDialog,
    private visitService: VisitService,
    transportDetailsLayoutConverter: TransportDetailsLayoutConverter,
    private transportDetailsLayoutService: TransportDetailsLayoutService
  ) {

    this.layoutDefinition = transportDetailsLayoutConverter.convert(
      this.transportDetailsLayoutService.createStationAssignmentTransportDetailsGridLayout()
    );

  }

  ngOnInit(): void {

    this.loadProfiles();

    if (this.actionItem.refreshTimer > 0) {

      this.timerSubscription = interval(this.actionItem.refreshTimer*1000).subscribe(n => {
        this.loadProfiles();
      });
    }
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = null;
    }
  }

  handleClick(transport: Transport) {

    var data = JSON.parse(this.actionItem.data);

    /* entrance action */
    if (data.action === 'entrance') {
      this.visitService.openRegisterEntranceDialog(transport.id, () => { });
    }

    /* leave action */
    if (data.action === 'leave') {
      if (this.cps.isPropertyTrue(this.clientParameters.FEATURES_COMBINED_LEAVE, false)) {
        const dialogData: RegisterLeaveCombinedDialogData = {
          transportId: transport.id,
          callback: () => {
            this.loadProfiles();
          }
        };

        this.dialog.open(RegisterLeaveCombinedComponent, {
          maxHeight: '95vh',
          data: dialogData
        });
      } else {
        const dialogData: RegisterLeaveDialogData = {
          transportId: transport.id,
          callback: () => {
            this.loadProfiles();
          }
        };

        this.dialog.open(RegisterLeaveComponent, {
          maxHeight: '95vh',
          data: dialogData
        });
      }
    }
  }

  private loadProfiles(): AsyncSubject<void> {

    var data = JSON.parse(this.actionItem.data);

    const subject = new AsyncSubject<void>();
    this.appServerApi.execute<Array<Transport>>('/tmc-yard/control/actionTabletTransport/getAll', data.customFilterId).subscribe(response => {
      let transports = new Array<Transport>();
      for (const transport of response) {
        transports.push(new Transport(transport));
      }
      this.transports = transports;
      subject.next();
      subject.complete();
    }, error => {
      subject.error('');
    });
    return subject;
  }

}
